export default __webpack_public_path__ + "static/media/GothamSSm-Bold.5b756473.svg";